import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'

export const fetchDnALoadDate = async (fYear: number): Promise<string | null> => {
  const url = proxy(`/webservice/197/sp/v4/spJBPDnALoadDate/call`)
  const payload = {
    'p.FYear': fYear,
  }
  const [accessToken] = getTokens()
  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = await Rest.post({ url, payload, headers })
  if (response?.Data && response?.Data.length > 0) {
    return response.Data[0].Created
  }

  return null
}
